import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grants-user-instructions',
  templateUrl: './grants-user-instructions.component.html',
  styleUrls: ['./grants-user-instructions.component.scss']
})
export class GrantsUserInstructionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
